/**
 * Форматирование рублей для UI.
 *
 * - Целое число → "12 ₽"
 * - С копейками → "12,50 ₽" (до 2 знаков, без хвостовых нулей)
 * - Большие числа разделяются неразрывным пробелом для читаемости
 */
export function formatRub(value: number): string {
  // toLocaleString('ru-RU') ставит U+00A0 (неразрывный пробел) для тысяч,
  // что нам и нужно — в UI разрывы внутри числа выглядят плохо.
  const formatted = value.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${formatted}\u00A0₽`;
}
